var _class;
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
import { action } from '@ember/object';
import Service from '@ember/service';
let DialogStackProvider = (_class = class DialogStackProvider extends Service {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "stack", []);
  }
  get dialogIsOpen() {
    return this.stack.length !== 0;
  }
  hasOpenChild(dialog) {
    return this.stack[this.stack.length - 1] !== dialog.guid;
  }
  remove(dialog) {
    let ix = this.stack.findIndex(guid => guid === dialog.guid);
    this.stack.splice(ix, 1);
  }
  push(dialog) {
    this.stack.push(dialog.guid);
  }
}, _applyDecoratedDescriptor(_class.prototype, "hasOpenChild", [action], Object.getOwnPropertyDescriptor(_class.prototype, "hasOpenChild"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "remove", [action], Object.getOwnPropertyDescriptor(_class.prototype, "remove"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "push", [action], Object.getOwnPropertyDescriptor(_class.prototype, "push"), _class.prototype), _class);
export { DialogStackProvider as default };